import reqest from "../common/reqest";




/**
 * 公告列表
 * @returns {Promise | Promise<unknown>}
 * @constructor
 */
export function getNoticeList(data) {
    return reqest.send("/Notice/get_notice_list", data);
}
